module.exports = __webpack_public_path__ + "static/media/invoicely.e698c241.png";